import React from 'react';
import {PreleadProject} from 'api';

interface Props {
  row: any;
}

const UserOfLatestTelActivityCell = ({row}: Props) => {
  const preleadProject: PreleadProject = row.original;

  return <span>{preleadProject.userOfLatestTelActivity}</span>;
};

export default UserOfLatestTelActivityCell;
